
/* tslint:disable:quotemark */
import { defineMessages } from "react-intl";


const MESSAGES = defineMessages({
  configurationDownload3D: {
    id: "ConfigurationDownload3D.text",
    defaultMessage: "Download 3D Scene",
  },
});

export default MESSAGES;